import actions from './actions'
import mutations from './mutations'
import getters from './getters'
import { Module } from 'vuex'
import { State } from '@/store/store'
import { PaymentState } from './states'

const AdsAccount: Module<PaymentState, State> = {
  state: new PaymentState(),
  actions,
  mutations,
  getters,
  namespaced: true,
}

export default AdsAccount
